import { useSearchParams } from "react-router-dom";
import parseUrlToQueryParams from "@/v2/utils/parseUrlToQueryParams";

export default function IndexCell({ index }: { index: number }) {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const { skip } = queryParams;

    return <div className="text-center">{skip + index + 1}</div>;
}
